export enum NotificationType {
  Group = 'Group',
  News = 'News',
  FAQ = 'FAQ',
  Instructor = 'Instructor',
  Room = 'Room',
  Event = 'Event',
  Task = 'Task',
  Survey = 'Survey',
  Course = 'Course',
  Message = 'Message',
  EventShift = 'EventShift',
  Banner = 'Banner',
}

export enum NotificationActionType {
  Accept = 'accept',
  Deny = 'deny',
  View_Survey = 'view survey',
  View = 'view',
  View_Task = 'view task',
}

export enum NotificationsActionTypes {
  Banners = 'banners',

  // GROUPS SECTION
  GroupNotifications = 'groupNotifications',
  UpdateGroupNotifications = 'updateGroupNotifications',
  UpdatedGroupNotificationForExistingUsers = 'updatedGroupNotificationForExistingUsers',
  UnapprovedUserGroups = 'unapprovedUserGroups',
  GroupForApprovals = 'groupForApprovals',
  DenyGroupNotifications = 'denyGroupNotifications',
  AcceptGroupUserNotifications = 'AcceptGroupUserNotifications',
  GetPublishedGroupNotificationToCreator = 'getPublishedGroupNotificationtoCreator',
  GroupNotificationExistingUsers = 'groupNotificationExistingUsers',

  // NEWS SECTION
  NewsNotifications = 'newsNotifications',
  UpdateNewsNotifications = 'updateNewsNotifications',
  DenyNewsNotifications = 'denyNewsNotifications',
  ApprovedPublishNewsNotificationToCreator = 'approvedPublishNewsNotificationToCreator',
  ApprovedUpdateNewsNotificationToCreator = 'approvedUpdateNewsNotificationToCreator',

  // EVENTS SECTION
  EventsNotifications = 'eventsNotifications',
  EventUpdateNotifications = 'eventUpdateNotifications',
  DenyEventNotificationsToCreator = 'denyEventNotificationsToCreator',
  ApprovedEventNotificationsToCreator = 'approvedEventNotificationsToCreator',
  ApprovedUpdateEventNotificationsToCreator = 'approvedUpdateEventNotificationsToCreator',
  InvitedEventsNotifications = 'invitedEventsNotifications',
  UpdatedEventNotificationForExistingUsers = 'updatedEventNotificationForExistingUsers',

  // COURSES SECTION
  CoursesNotifications = 'coursesNotifications',
  UpdateCourseNotifications = 'updateCourseNotifications',
  UserWantsToJoinCourseNotificationToCreator = 'userWantsToJoinCourseNotificationToCreator',
  UserJoinedByCreatorNotification = 'userJoinedByCreatorNotification',
  InvitedCoursesNotifications = 'invitedCoursesNotifications',
  UpdatedCourseNotificationForExistingUsers = 'updatedCourseNotificationForExistingUsers',
  InternalCourseInstructorNotifications = 'internalCourseInstructorNotifications',
  InternalUpdateCourseInstructorNotifications = 'internalUpdateCourseInstructorNotifications',
  ApprovedCourseNotificationsToCreator = 'approvedCourseNotificationsToCreator',
  ApprovedUpdateCourseNotificationsToCreator = 'approvedUpdateCourseNotificationsToCreator',
  DenyCourseNotificationsToCreator = 'denyCourseNotificationsToCreator',

  // TASKS SECTION
  TaskNotifications = 'taskNotifications',
  UpdateTasksNotifications = 'updateTasksNotifications',
  UnapprovedTasks = 'unapprovedTasks',
  UnapprovedSubTask = 'unapprovedSubTask',
  GetDenyPublishTaskByAdminNotificationstoCreator = 'getDenyPublishTaskByAdminNotificationstoCreator',
  GetAcceptPublishTaskByAdminNotificationstoCreator = 'getAcceptPublishTaskByAdminNotificationstoCreator',
  AcceptUpdatedTaskByAdminNotificationstoCreator = 'acceptUpdatedTaskByAdminNotificationstoCreator',
  UpdatedTaskNotificationForExistingUsers = 'updatedTaskNotificationForExistingUsers',
  CompletedTaskNotificationToOrganizer = 'completedTaskNotificationToOrganizer',

  // MESSAGE SECTION
  MessageNotifications = 'messageNotifications',

  // SURVEYS SECTION
  SurveyNotifications = 'surveyNotifications',
  UpdateSurveyNotification = 'updateSurveyNotification',
  InvitedSurveyNotifications = 'invitedSurveyNotifications',
  GetAcceptPublishSurveyByAdminNotificationstoCreator = 'getAcceptPublishSurveyByAdminNotificationstoCreator',
  PublishUpdateSurveyByAdminNotificationstoCreator = 'publishUpdateSurveyByAdminNotificationstoCreator',
  GetDenyPublishSurveyByAdminNotificationstoCreator = 'getDenyPublishSurveyByAdminNotificationstoCreator',

  // ROOMS SECTION
  RoomNotifications = 'roomNotifications',
  RoomUpdateNotifications = 'roomUpdateNotifications',
  ApprovedRoomNotificationsToCreator = 'approvedRoomNotificationsToCreator',
  ApprovedUpdateRoomNotificationsToCreator = 'approvedUpdateRoomNotificationsToCreator',
  DenyRoomNotificationsToCreator = 'denyRoomNotificationsToCreator',

  // INSTRUCTOR SECTION
  InstructorNotifications = 'instructorNotifications',
  UpdateInstructorNotifications = 'updateInstructorNotifications',
  DenyInstructNotificationsToCreator = 'denyInstructNotificationsToCreator',
  ApprovedInstructNotificationsToCreator = 'approvedInstructNotificationsToCreator',
  ApprovedUpdateInstructNotificationsToCreator = 'approvedUpdateInstructNotificationsToCreator',

  // FAQS SECTION
  FaqsNotifications = 'faqsNotifications',
  UpdateFaqsNotificationToadmin = 'updateFaqsNotificationToadmin',
  ApprovedFaqNotification = 'approvedFaqNotification',
  UpdateFaqsNotificationToAuthor = 'updateFaqsNotificationToAuthor',
  FaqsDenyNotificationToAuthor = 'faqsDenyNotificationToAuthor',
  FaqsCategoryNotifications = 'faqsCategoryNotifications',
}

export enum GetDenySectionToEndpoints {
  group = 'getAdminDenyGroups/',
  task = 'get-users-denytask/',
  instructor = 'get-users-denyinstructor/',
  room = 'get-users-denyroom/',
  event = 'get-users-denyevent/',
  course = 'get-admin-denyCourses/',
  survey = 'get-users-denysurvey/user_id/',
  news = 'get-users-denynews/',
  faq = 'get-users-denyfaq/',
}

export enum Endpoints {
  GROUP_GET = 'get-reset-updatedGroupDetails/group_id/',
  GROUP_DELETE = 'deleteGroup/',
  TASK_GET = 'get-reset-updatedtask/',
  TASK_DELETE = 'DeleteTask/',
  INSTRUCTOR_GET = 'get-reset-updatedinstructor/',
  INSTRUCTOR_DELETE = 'deleteInstructor/',
  ROOM_GET = 'get-reset-updatedroom/',
  ROOM_DELETE = 'deleteRooms/',
  SURVEY_GET = 'get-reset-updatedsurvey/',
  SURVEY_DELETE = 'deleteSurvey/',
  EVENT_GET = 'get-reset-updatedevent/',
  EVENT_DELETE = 'event/',
  COURSE_GET = 'get-reset-updatedCourses/',
  COURSE_DELETE = 'deleteCourse/',
  FAQS_GET = 'get-reset-updatedfaq/',
  FAQS_DELETE = 'deleteFaq/',
}
